var sw  = require('js/lib/sw');
var $   = require('js/sw-jquery/sw-jquery');

//this is called when the checkboxes for email preference is changed
function onEmailPreferenceCheckboxChanged()
{
  //send out the post request//Get the form data
  var $data = $('#emailpreferences_form').serialize() + '&' + sw.data.email_preference_checkbox_changed_param;

  //send out the request
  $.ajax({
    type:"POST",
    async:true,
    url: '/settings/email',
    data: $data,
    dataType: 'json',
    success: function (response_data) {
      window.sw.notifications.success(response_data.response_text);
    },
    failure: function () {

    }
  });


  return false;
}

$(document).ready(function () {

  //make all the checkboxes within the form have functionalityyy
  $('#emailpreferences_form :checkbox').change(onEmailPreferenceCheckboxChanged);
  $('#emailpreferences_form select').change(onEmailPreferenceCheckboxChanged);
});